import { PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import React from "react";
import ReactDOM from "react-dom/client";
import Connect from "./connect/Connect.tsx";
import { ConnectProvider } from "./connect/ConnectContext.tsx";
import "./index.css";
import "./sentry.ts";
import TRPCProvider from "./utils/TRPCProvider.tsx";

if (import.meta.env.VITE_POSTHOG_KEY) {
  // Check if we're embedded in the dashboard
  const isEmbeddedInDashboard = (() => {
    if (window.parent === window) return false;
    const dashboardUrl =
      import.meta.env.VITE_DASHBOARD_URL || "https://dash.bridge.com.do";
    try {
      const parentOrigin = document.referrer
        ? new URL(document.referrer).origin
        : "";
      return parentOrigin === new URL(dashboardUrl).origin;
    } catch {
      return false;
    }
  })();

  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com",
    defaults: "2025-05-24",
    session_recording: {
      maskAllInputs: true,
      // Enable cross-origin iframe recording only when embedded in dashboard
      recordCrossOriginIframes: isEmbeddedInDashboard,
    },
    loaded: (posthog) => {
      if (import.meta.env.DEV) posthog.debug();
    },
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <TRPCProvider>
        <ConnectProvider>
          <Connect />
        </ConnectProvider>
      </TRPCProvider>
    </PostHogProvider>
  </React.StrictMode>
);
